import * as constants from './actions';
import { getInitiatedTime, getTimeFrom } from '../../utils/actionTiming';

const initialState = {
    repStanceOverlayVisibile: false,
    repStanceLoading: false,
    repStanceUnavailable: false,
    repStanceCompleted: false,
    noOfAnswers: null,
    popupErrorMessage: null,
    defaultRepSearch: {
        id: 0,
        levels: [0],
        roles: [0, 1]
    },
    stances: []
};

export default function repStance(state = initialState, { type, payload }) {
    switch (type) {
        case constants.REP_STANCE_INITATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                repStanceInitiated: true
            };
        case constants.REP_STANCE_ACTION_UPDATED:
            return {
                ...state,
                actionCompletionTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.REP_STANCE_LOADING:
            return {
                ...state,
                repStanceLoading: payload,
                repStanceUnavailable: false,
                popupErrorMessage: null
            };
        case constants.REP_STANCE_UNAVAILABLE:
            return {
                ...state,
                repStanceUnavailable: payload.bool,
                popupErrorMessage: payload.popupErrorMessage
            };
        case constants.REP_STANCE_COMPLETED:
            return {
                ...state,
                noOfAnswers: payload.counter,
                repStanceCompleted: true,
                actionCompletionTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload.actionIdentifier, state))[0]
                )
            };
        case constants.SET_REP_STANCE:
            return {
                ...state,
                stances: payload
            };
        default:
            return state;
    }
}
